import { render, staticRenderFns } from "./SeminarEntryMessageRegister.vue?vue&type=template&id=26f60e24"
import script from "./SeminarEntryMessageRegister.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports